import { render, staticRenderFns } from "./DefaultLayoutNoMenu.vue?vue&type=template&id=b7fb0834&scoped=true&"
import script from "./DefaultLayoutNoMenu.vue?vue&type=script&lang=js&"
export * from "./DefaultLayoutNoMenu.vue?vue&type=script&lang=js&"
import style0 from "./DefaultLayoutNoMenu.vue?vue&type=style&index=0&id=b7fb0834&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7fb0834",
  null
  
)

export default component.exports